import { Layout } from "antd";
import { MenuLateral } from "shared/components";
import "./Layout.scss";

const { Content } = Layout;

const LayoutEstagio: React.FC<{ children?: React.ReactNode }> = (props) => {
  const { children } = props;

  return (
    <Layout className="layout-mobile">
      <MenuLateral />
      <Content className="mobile-content">{children}</Content>
    </Layout>
  );
};

export default LayoutEstagio;
